import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";
import Logo from "./Logo";
import { OFFICE } from "../data/content";

export default function SiteFooter() {
  return (
    <footer className="bg-navy-dark text-cream" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4 space-y-5">
            <Logo size={48} light />
            <p className="text-sm text-cream/70 leading-relaxed">
              One Place. Every Step. Full Circle. We organize immigration and integration needs into one clear journey.
            </p>
            <div className="space-y-2 text-sm text-cream/80">
              <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-champagne" /> {OFFICE.address}, {OFFICE.city}</p>
              <p className="flex items-center gap-2"><Mail className="h-4 w-4 text-champagne" /> <a href={`mailto:${OFFICE.email}`} className="hover:text-champagne transition-colors">{OFFICE.email}</a></p>
              <p className="flex items-center gap-2"><Phone className="h-4 w-4 text-champagne" /> <a href={`tel:${OFFICE.phone}`} className="hover:text-champagne transition-colors">{OFFICE.phone}</a></p>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-sans font-semibold tracking-[0.15em] uppercase text-champagne mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-cream/80">
              <li><Link to="/immigration" className="hover:text-champagne transition-colors">Immigration</Link></li>
              <li><Link to="/documents-identity" className="hover:text-champagne transition-colors">Documents &amp; Identity</Link></li>
              <li><Link to="/itin-tax" className="hover:text-champagne transition-colors">ITIN &amp; Tax</Link></li>
              <li><Link to="/screening" className="hover:text-champagne transition-colors">Screening &amp; Verification</Link></li>
              <li><Link to="/new-life" className="hover:text-champagne transition-colors">New Life Services</Link></li>
              <li><Link to="/citizenship" className="hover:text-champagne transition-colors">Citizenship</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-sans font-semibold tracking-[0.15em] uppercase text-champagne mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-cream/80">
              <li><Link to="/about" className="hover:text-champagne transition-colors">About</Link></li>
              <li><Link to="/resources" className="hover:text-champagne transition-colors">Resources</Link></li>
              <li><Link to="/contact" className="hover:text-champagne transition-colors">Contact</Link></li>
              <li><Link to="/legal?tab=careers" className="hover:text-champagne transition-colors">Careers</Link></li>
              <li><Link to="/legal?tab=partner" className="hover:text-champagne transition-colors">Partner With Us</Link></li>
              <li><Link to="/portal" className="hover:text-champagne transition-colors">Client Portal</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-sans font-semibold tracking-[0.15em] uppercase text-champagne mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-cream/80 mb-6">
              <li><Link to="/legal?tab=privacy" className="hover:text-champagne transition-colors">Privacy Policy</Link></li>
              <li><Link to="/legal?tab=terms" className="hover:text-champagne transition-colors">Terms of Use</Link></li>
              <li><Link to="/legal?tab=disclosures" className="hover:text-champagne transition-colors">Legal Disclosures</Link></li>
              <li><Link to="/legal?tab=accessibility" className="hover:text-champagne transition-colors">Accessibility</Link></li>
              <li><Link to="/legal?tab=rights" className="hover:text-champagne transition-colors">Client Rights</Link></li>
              <li><Link to="/legal?tab=emergency" className="hover:text-champagne transition-colors">Emergency Disclaimer</Link></li>
            </ul>
            <p className="text-xs text-cream/60 leading-relaxed" data-testid="footer-disclaimer">
              CF Full Circle is not affiliated with USCIS, the U.S. Department of Justice, the Department of State, the Internal Revenue Service, or any other government agency. Immigration legal representation is offered only through appropriately authorized attorneys or DOJ Accredited Representatives acting through their recognized organization and within their authorized scope. Government agencies make all decisions regarding immigration benefits, passports, visas, vital records, identification documents, tax identification numbers, and other government-issued documents. No outcome is guaranteed.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-cream/50">© {new Date().getFullYear()} CF Full Circle Immigration &amp; Integration Center. All rights reserved.</p>
          <p className="text-xs text-champagne tracking-[0.2em] uppercase font-medium">One Place. Every Step. Full Circle.</p>
        </div>
      </div>
    </footer>
  );
}
